export default class Accordion {
    constructor() {
        this.elementSelector = '[data-accordion]';
        this.header = '[data-accordion-header]';
        this.content = '[data-accordion-content]';
        this.item = '[data-accordion-item]';
        this.dataTagCloseOtherItems = 'data-accordion-close-other-items';
        this.closeOtherItems = false;
        this.activeClass = 'active';
    }

    init() {
        // early exit
        const elements = document.querySelectorAll(this.elementSelector);

        if (elements.length === 0) {
            return false;
        }

        this.bindEvents(elements);
    }

    bindEvents(accordions) {
        accordions.forEach((accordion) => {
            this.closeOtherItems = accordion.getAttribute(this.dataTagCloseOtherItems) === 'true';
            accordion.querySelectorAll(this.header).forEach((accordionHeader) => {
                accordionHeader.addEventListener('click', (e) => {
                    const itemContent = e.target.closest(this.item).querySelector(this.content);

                    if (accordionHeader.classList.contains(this.activeClass)) {
                        this.closeAccordionItem(accordionHeader, itemContent);
                    } else if (this.closeOtherItems) {
                        this.closeActiveAccordionItem(accordion);
                        this.openAccordionItem(accordionHeader, itemContent);
                    } else {
                        this.openAccordionItem(accordionHeader, itemContent);
                    }
                });
            });
        });
    }

    openAccordionItem(element, elementContent) {
        element.classList.add(this.activeClass);
        elementContent.classList.add(this.activeClass);
    }

    closeAccordionItem(element, elementContent) {
        element.classList.remove(this.activeClass);
        elementContent.classList.remove(this.activeClass);
    }

    closeActiveAccordionItem(accordion) {
        accordion.querySelectorAll(this.item).forEach((accordionItem) => {
            [this.header, this.content].forEach((selector) => {
                accordionItem.querySelector(selector).classList.remove(this.activeClass);
            });
        });
    }
}
